import React from 'react';
import useAuth from '../../hooks/useAuth';
import PendingPage from '../../pages/PendingPage';
import SignupFlow from '../../pages/SignupFlow';
import LandingPage from '../../pages/LandingForkRoadPage';

const AuthGate = ({ children }) => {
  const { isLoggedIn, isActive, signupComplete, isLoading } = useAuth();

  // Render landing while auth resolves — no spinner gate, since /api/auth/me
  // can take 4-5s on a cold Lambda and there's nothing for the user to do
  // during the wait. Logged-in users see landing for one frame before
  // swapping to the app shell.
  if (isLoading || !isLoggedIn) {
    return <LandingPage />;
  }

  if (!signupComplete) {
    return <SignupFlow />;
  }

  if (!isActive) {
    return <PendingPage />;
  }

  return children;
};

export default AuthGate;
